import DeleteIcon from '@mui/icons-material/Delete';
import {
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Control, FieldErrors } from 'react-hook-form';

import { PERCENTAGES_DO_NOT_SUM_TO_100 } from './constants';
import PercentField from './PercentField';

import { FormValues } from '../AllocationTemplateForm';
import SubAccountDetailRow from '../SubAccountDetailRow';

const LineItemDetails = ({
  control,
  validationErrors,
  handleRemoveRow,
  rows,
}: {
  control: Control<FormValues, any, FormValues>;
  validationErrors?: string[];
  handleRemoveRow: (subAccountId: string) => void;
  rows: SubAccountDetailRow[];
}) => {
  return (
    <>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Account Number</TableCell>
            <TableCell align="right" width={160}>
              Cost %
            </TableCell>
            <TableCell align="right" width={160}>
              Usage %
            </TableCell>
            <TableCell width={56} />
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={row.subAccountId}>
              <TableCell>{row.number}</TableCell>
              <TableCell align="right">
                <PercentField
                  control={control}
                  name={`details.${index}.costPercent`}
                />
              </TableCell>
              <TableCell align="right">
                <PercentField
                  control={control}
                  name={`details.${index}.usagePercent`}
                />
              </TableCell>
              <TableCell padding="none">
                <IconButton
                  size="small"
                  onClick={() => handleRemoveRow(row.subAccountId)}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {validationErrors?.length > 0 && (
        <Stack alignItems="flex-end" sx={{ pt: 1 }}>
          <Typography variant="body2" color="error">
            {PERCENTAGES_DO_NOT_SUM_TO_100}
          </Typography>
        </Stack>
      )}
    </>
  );
};

export default LineItemDetails;
